module.exports = __webpack_public_path__ + "img/logo-elasoft-text-red.570ffbec.svg";